import { render } from "./RunningTotal.vue?vue&type=template&id=2d5de648&scoped=true&bindings={\"getDebug\":\"options\",\"getTotalPrice\":\"options\",\"getTransportDiscount\":\"options\",\"getBookingDates\":\"options\",\"ISO2Uk\":\"options\"}"
import script from "./RunningTotal.vue?vue&type=script&lang=js"
export * from "./RunningTotal.vue?vue&type=script&lang=js"

import "./RunningTotal.vue?vue&type=style&index=0&id=2d5de648&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d5de648"

export default script